import { render, staticRenderFns } from "./AddDatVersionDialog.vue?vue&type=template&id=685a3fc2&scoped=true"
import script from "./AddDatVersionDialog.vue?vue&type=script&lang=ts"
export * from "./AddDatVersionDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddDatVersionDialog.vue?vue&type=style&index=0&id=685a3fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a3fc2",
  null
  
)

export default component.exports